export default "__VITE_ASSET__CrUI1r3W__"